import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { downloadFile, formatData, groupBy, isNullOrEmpty, showMessageToastCustom, translate, showMessageToast } from '../../../../utils/util';
import { BackButton, Input, Label, Select, Title, Button, Modal } from '../../../../components/UI/ComponentsUI';
import { onValueChange, validateInputsRequired } from '../../../../utils/handleChangeHooks';
import FilterJourneyMvm from '../FilterJourneyMvm';
import CollapsibleUI from '../../../../components/UI/CollapsibleUI';
import FormPartNumber from '../Form/FormPartNumber';
import { ENUMS } from '../../../../utils/constants';
import StockService from '../../../../services/StockService';
import TextAreaUI from '../../../../components/UI/TextAreaUI';
import SelectResourceForm from '../Form/SelectResourceForm';
import SelectNew from '../../../../components/UI/SelectNew';

const SqpForm = (props) => {
    const update = props.location?.state?.update;
    const defaultDataForm = {
        mvmNumber: '',
        journey: '',
        invoice: '',
        bonus: '',
        areaId: '',
        uleId: '',
        vehicleId: '',
        ticket: '',
        observation: '',
        supplier: '',
        supplierName: '',
        areas: '',
        leader: '',
        email: props.user?.email || '',
        inCharge: '',
        createdOn: new Date(),
        createdBy: props.user?.userName || '',
        createdByDesc: props.user?.name || '',
        isCarriedOut: false,
        type: ENUMS.eFormType.Sqp.value,
        items: [],
        questions: [],
        printer: undefined
    };

    const [data, setData] = useState();
    const [openModalPrintDownload, setOpenModalPrintDownload] = useState(false);
    const [openModalConfirm, setOpenModalConfirm] = useState(false);
    const [receipt, setReceipt] = useState();
    const [invoices, setInvoices] = useState([]);
    const [images, setImages] = useState(update && props.sqp?.images ? props.sqp?.images : []);
    const [dataForm, setDataForm] = useState(update ? props.sqp : defaultDataForm);
    const [areas, setAreas] = useState([]);
    const [ules, setUles] = useState([]);
    const [vehicles, setVehicles] = useState([]);
    const [questions, setQuestions] = useState([]);

    useEffect(() => {
        props.getAreasAll({}, (data) => {
            setAreas(data);
        });
        props.getUlesAll({}, (data) => {
            setUles(data);
        });
        props.getVehiclesAll({}, (data) => {
            setVehicles(data);
        });
        props.getQuestionsAll({ type: ENUMS.eFormType.Sqp.value }, (data) => {
            setQuestions(data);
        });
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (!isNullOrEmpty(dataForm?.invoice) && data) {
            let dataObj = {};
            Object.assign(dataObj, data);
            dataObj.receipts = dataObj.receipts.filter((f) => f.invoice === dataForm.invoice);
            setData({ ...dataObj });
            onGetArea();
        } else {
            setReceipt();
        }

        // eslint-disable-next-line
    }, [dataForm?.invoice]);

    const onChange = (event) => {
        onValueChange(event, dataForm, setDataForm);
    };

    const onSetData = (data) => {
        if (data) {
            if (!update) {
                dataForm.items = [];
                dataForm.questions = [];
                dataForm.invoice = '';
                dataForm.mvmNumber = data.mvmNumber;
                dataForm.journey = data.journey;
                dataForm.email = props.user?.email || '';
                dataForm.createdOn = new Date();
                dataForm.createdBy = props.user?.userName || '';
                dataForm.createdByDesc = props.user?.name || '';
                setDataForm({ ...dataForm });
            }

            setReceipt();
            setData({ ...data });

            if (props.sqp?.fromReceipt) {
                setPartnumberFromReceipt(props.sqp.partNumberCode, data.receipts)
            }

            if (data.receipts && data.receipts.length > 0) {
                const invoiceGroup = groupBy(data.receipts, 'invoice');
                let invoiceArray = []
                invoiceGroup.forEach((invoice) => {
                    invoiceArray.push(
                        { id: invoice.key, text: invoice.key }
                    );
                })
                setInvoices([...invoiceArray]);
            }
        } else {
            setData();
            setReceipt();
        }
    }

    const setPartnumberFromReceipt = (event, dataReceipts) => {
        var Receipt = dataReceipts.find((f) => f.partNumberCode === event);
        if (Receipt) {
            setReceipt({ ...Receipt })
        }
    };

    const onChangeSelect = (event) => {
        let item = dataForm.items?.find(x => x.partNumberCode === event);
        if (isNullOrEmpty(item)) {
            var Receipt = data.receipts.find((f) => f.partNumberCode === event);
            if (Receipt) {
                setReceipt({ ...Receipt })
            }
        } else {
            showMessageToast({ html: `Desenho ${event} já adicionado`, classes: 'red' });
        }
    };

    const onGetArea = () => {
        if (data && data.receipts) {
            var areas = [];
            data.receipts.forEach(element => {
                if (!isNullOrEmpty(element.almox) && !areas.find(f => f === element.almox)) {
                    areas.push(element.almox);

                }
            });
            dataForm.areas = areas.join(", ");
            setDataForm({ ...dataForm })
        }
    };

    const addImages = (id, image) => {
        if (images) {
            let newImage = { id: id, image: image };
            if (!isNullOrEmpty(image)) {
                newImage.url = URL.createObjectURL(image)
            }
            images.push(newImage);
            setImages([...images]);
            document.getElementById("image").value = "";
        }
    };

    const onChangeReceipt = (event) => {
        onValueChange(event, receipt, setReceipt);
    };

    const addItem = (callback) => {
        if (dataForm && dataForm.items && !dataForm.items.find(f => f.id === receipt.id)) {
            var itemPartNumber = {
                partNumberCode: receipt.partNumberCode,
                partNumberDescription: receipt.partNumberDescription,
                declaredLabelQuantity: parseInt((receipt?.accoutingQuantity || 1) / (receipt.qme || 1) > 0 ? 1 : 0),
                declaredQuantity: receipt.accoutingQuantity,
                receivedLabelQuantity: receipt.volumeReceived,
                receivedQuantity: receipt.amountReceived,
                deem: receipt.deem,
                mdr: receipt.mdr,
                sqpNew: receipt.sqpNew
            };
            dataForm.items.push(itemPartNumber);
            setDataForm({ ...dataForm });
            setReceipt();
            if (callback) {
                callback();
            }
        }
    };

    const removedItem = (item) => {
        if (dataForm && dataForm.items) {
            dataForm.items = dataForm.items.filter(f => f.id !== item.id);
            setDataForm({ ...dataForm });
        }
    };

    const onChangeSupplier = (supplier) => {
        dataForm.supplierName = supplier.name.trim();
        setDataForm({ ...dataForm });
    };

    const validationSend = (isUpdateOnly) => {
        if (dataForm.items.length > 0 && validateInputsRequired("filterInvoiceMvm") && validateInputsRequired("filterArea")) {
            if (isUpdateOnly) {
                updatewithoutPrint();
            }
            else {
                setOpenModalPrintDownload(true);
            }
        } else {
            showMessageToastCustom(translate('warning', 'general'), translate('obligatory-fields', 'volume'), 3000, 'mdi mdi-alert-circle-outline red-text');
        }
    };

    const updatewithoutPrint = () => {
        dataForm.images = images.filter(x => !isNullOrEmpty(x.formId))
        let newImages = images.filter(x => isNullOrEmpty(x.formId))
        props.editForm(dataForm, newImages, () => {
            showMessageToastCustom(translate('general.info'), translate('sucess-to-update', 'general'), 2000, 'mdi mdi-checkbox-marked-circle-outline green-text');
            redirect();
        })
    }

    const onConfirm = () => {
        dataForm.images = images.filter(x => !isNullOrEmpty(x.formId))
        let newImages = images.filter(x => isNullOrEmpty(x.formId))
        if (!update) {
            props.addForm(dataForm, newImages, (response) => {
                downloadFile(response.report, `sqp${response.form.id}.pdf`, "data:application/pdf", true)
                reset()
                redirect();
            })
        } else {
            props.editForm(dataForm, newImages, (response) => {
                downloadFile(response.report, `sqp${response.form.id}.pdf`, "data:application/pdf", true)
                reset()
                redirect();
            })
        }
    }

    const redirect = () => {
        if (props.sqp?.fromReceipt) {
            props.history.push({ pathname: './../../receipt/V2/receiptStorages' })
        }
        else {
            props.history.go(-1);
        }
    }

    const reset = () => {
        setDataForm({ ...defaultDataForm });
        setData();
        setReceipt();
        setInvoices([]);
        setImages();
    }

    const removeImage = (index) => {
        const imagesFilter = images;
        imagesFilter.splice(index, 1);
        setImages([...imagesFilter]);
    }

    const editPartnumber = (item) => {
        let list = [];
        Object.assign(list, dataForm.items);

        let itemDataForm = list.find(f => f.partNumberCode === item.partNumberCode);

        itemDataForm.receivedLabelQuantity = item.receivedLabelQuantity
        itemDataForm.receivedQuantity = item.receivedQuantity
        setDataForm({ ...dataForm, items: list });
    }

    const addAnswer = (item, value) => {
        let question = dataForm.questions.find(x => x.questionId === item.id);

        if (question !== undefined) {
            question.answerId = value
        } else {
            dataForm.questions.push({
                questionId: item.id,
                answerId: value,
            });
        }
    };

    return (
        <div>
            <BackButton {...props} />
            <div className="container-fluid h-65">
                <Title icon="mdi mdi-clipboard-list-outline" label={translate('deemsqp:menu.sqp-form')} />
            </div>

            <div className="container-fluid" style={{ marginTop: '30px' }}>
                <FilterJourneyMvm callback={onSetData} update={update} type={defaultDataForm.type} />
                {data && invoices.length > 0 &&
                    <>
                        <div className="container" style={{ marginTop: '0px', }}>
                            <CollapsibleUI
                                id="filterArea"
                                header={translate('stock:form.title-area')}
                                body={
                                    <div>
                                        <div className="row">
                                            <div className="input-field no-padding col s12 m5 l3">
                                                <SelectNew
                                                    required
                                                    id="areaId"
                                                    name="areaId"
                                                    display="name"
                                                    label={translate('stock:form.area')}
                                                    placeHolder={translate('choose-one-option', 'general')}
                                                    data={areas ? areas.map((i) => {
                                                        return { id: i.id, text: i.description };
                                                    }) : []}
                                                    change={(e) => {
                                                        onChange(e);
                                                    }}
                                                    value={dataForm.areaId || ''}
                                                />
                                            </div>
                                            <div className="input-field no-padding  col s12 m5 l3">
                                                <SelectNew
                                                    required
                                                    id="uleId"
                                                    name="uleId"
                                                    display="name"
                                                    label="ULE"
                                                    placeHolder={translate('choose-one-option', 'general')}
                                                    data={ules
                                                        ? ules.map((i) => {
                                                            return { id: i.id, text: i.description };
                                                        }) : []}
                                                    change={(e) => {
                                                        onChange(e);
                                                    }}
                                                    value={dataForm.uleId || ''}
                                                />
                                            </div>
                                            <div className="input-field no-padding  col s12 m5 l3">
                                                <SelectNew
                                                    required
                                                    id="vehicleId"
                                                    name="vehicleId"
                                                    display="name"
                                                    label={translate('stock:form.vehicle-model')}
                                                    placeHolder={translate('choose-one-option', 'general')}
                                                    data={vehicles
                                                        ? vehicles.map((i) => {
                                                            return { id: i.id, text: i.description };
                                                        }) : []}
                                                    change={(e) => {
                                                        onChange(e);
                                                    }}
                                                    value={dataForm?.vehicleId || ''}
                                                />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="input-field no-padding col s12 m4 l3">
                                                <Label
                                                    label={translate('stock:form.name')}
                                                    value={dataForm.createdByDesc || ''} />
                                            </div>
                                            <div className="input-field no-padding col s6 m4 l3">
                                                <Label
                                                    label={translate('stock:form.record')}
                                                    value={dataForm.createdBy || ''} />
                                            </div>
                                            <div className="input-field no-padding col s6 m4 l3">
                                                <Label
                                                    label={translate('stock:form.date')}
                                                    value={formatData(dataForm.createdOn) || ''} />
                                            </div>
                                            <div className="input-field no-padding  col s12 m7 l3">
                                                <i className="material-icons prefix">mail</i>
                                                <Input
                                                    label={translate('stock:form.email')}
                                                    id="email"
                                                    name='email'
                                                    onChange={onChange}
                                                    value={dataForm.email || ''}
                                                    maxLength="100"
                                                />
                                            </div>
                                            <div className="input-field no-padding  col s4">
                                                <i className="material-icons prefix">phone</i>
                                                <Input
                                                    type="tel"
                                                    label={translate('stock:form.phone')}
                                                    id="phone"
                                                    name='phone'
                                                    onChange={onChange}
                                                    value={dataForm.phone || ''}
                                                    maxLength="20"
                                                />
                                            </div>
                                        </div>
                                    </div>}
                            />
                        </div>
                        {
                            data &&
                            <>
                                <FormPartNumber
                                    onChangeSupplier={onChangeSupplier}
                                    receipt={receipt}
                                    dataForm={dataForm}
                                    data={data}
                                    onChange={onChange}
                                    onChangeSelect={onChangeSelect}
                                    onChangePartNumber={onChangeReceipt}
                                    addItem={addItem}
                                    removedItem={removedItem}
                                    editPartnumber={(editedItem) => editPartnumber(editedItem)}
                                    filterPartNumber={props.sqp && props.sqp.fromReceipt ? props.sqp?.partNumberCode : ''}
                                />
                                <div className="container" >
                                    <CollapsibleUI
                                        id="filterQuestions"
                                        header={`Itens de Disturbio - Logística Interna`}
                                        simple="true"
                                        close="true"
                                        body={
                                            <>
                                                <div id="formFilterQuestions" className="card-content" style={{ paddingBlockEnd: '1px' }}>
                                                    {questions.map((item, index) => {
                                                        let ans = dataForm.questions.find(x => x.questionId === item.id)
                                                        return (
                                                            <div key={index}>
                                                                <b className="black-text" style={{ marginTop: '10px' }}>
                                                                    {item.description}
                                                                </b>
                                                                <div className="input-field no-padding col s12" style={{ marginLeft: '20px' }}>
                                                                    <Select
                                                                        required
                                                                        id="answer"
                                                                        name="answer"
                                                                        display="text"
                                                                        placeHolder={translate('choose-one-option', 'general')}
                                                                        data={questions.find(f => f.id === item.id)?.answers.map((i) => {
                                                                            return { id: i.id, text: i.description };
                                                                        })}
                                                                        change={(e) => {
                                                                            addAnswer(item, e.target.value);
                                                                        }}
                                                                        defaultValue={ans?.answerId}
                                                                    />
                                                                </div>
                                                            </div>
                                                        )
                                                    })}
                                                </div>
                                                <div className="input-field no-padding  col s12">
                                                    <TextAreaUI
                                                        label="Observações Gerais"
                                                        defaultValue={dataForm?.observation || ''}
                                                        id="observation"
                                                        name="observation"
                                                        onChange={onChange}
                                                        data-length="300" />

                                                </div>
                                            </>

                                        }
                                    ></CollapsibleUI>
                                </div>
                                <div className="container" >
                                    <CollapsibleUI
                                        id="filterImage"
                                        header={translate('stock:form.images')}
                                        body={
                                            <div id="formInput" className="card-content" style={{ padding: '10px', paddingBlockEnd: '1px', paddingBottom: '30px' }}>
                                                <div className="card-panel hoverable">
                                                    {images?.map((i, index) => {
                                                        return (
                                                            <div key={`key_${index}`} className="list sixth-text-color" style={{ paddingRight: '15px' }}>
                                                                <img src={i.url} style={{ width: '100px', height: '100px' }} alt={`${index}`} />
                                                                <i onClick={() => removeImage(index)} className={'mdi mdi-21px mdi-alpha-x-circle-outline'} />
                                                            </div>
                                                        )
                                                    })}
                                                </div>
                                                {images.length < 3 &&
                                                    <Input
                                                        id="image"
                                                        type="file"
                                                        accept="image/*"
                                                        onChange={(event) => {
                                                            addImages(1, event.target.files[0])
                                                        }}
                                                    />
                                                }
                                            </div>
                                        }
                                    ></CollapsibleUI>
                                </div>
                                <div className="container" >
                                    <CollapsibleUI
                                        id="filterTicket"
                                        header={translate('stock:form.ticket')}
                                        body={
                                            <div id="formTicket" className="card-content" style={{ padding: '10px', paddingBlockEnd: '1px' }}>
                                                <div className="input-field no-padding  col s4">
                                                    <Input
                                                        label={translate('stock:form.ticket')}
                                                        id="ticket"
                                                        name="ticket"
                                                        value={dataForm.ticket}
                                                        onChange={onChange}

                                                    />
                                                </div>
                                            </div>
                                        }
                                    ></CollapsibleUI>
                                </div>
                                <div className="container" >
                                    <div id="formInput" className="card-content" style={{ paddingBlockEnd: '1px' }}>
                                        <div className="row" style={{ marginTop: '20px' }}>
                                            <Button full="true" text={translate('stock:form.send')} onClick={() => {
                                                validationSend(false);
                                            }} />
                                        </div>
                                        {update &&
                                            <div className="row" style={{ marginTop: '20px' }}>
                                                <Button full="true" secundary='true' text={translate('menu.update', 'configuration')} onClick={() => {
                                                    validationSend(true);
                                                }} />
                                            </div>
                                        }
                                    </div>
                                </div>
                            </>
                        }
                    </>
                }
            </div>

            <Modal
                open={openModalPrintDownload}
                maxHeight="45%"
                id="ModalPrintDownload"
                title={`Gerar Relatório SQP`}
                content={`Informe o Recurso para impressão automatica`}
                children={<SelectResourceForm onChangePrinter={(printer) => {
                    dataForm.printer = printer;
                    setDataForm(dataForm);
                }} />}
                dismissible={false}
                onConfirm={() => { setOpenModalPrintDownload(false); setOpenModalConfirm(true); }}
                onCancel={() => {
                    dataForm.printer = undefined;
                    setDataForm(dataForm);
                    setOpenModalPrintDownload(false)
                }}
                btnConfirm="Gerar"
                btnCancel="Cancelar"
            />
            <Modal
                open={openModalConfirm}
                maxHeight="45%"
                id="ModalConfirm"
                title={`Confirmar geração de relatório?`}
                dismissible={false}
                onConfirm={() => {
                    setOpenModalConfirm(false);
                    onConfirm();
                }}
                onCancel={() => {
                    setOpenModalConfirm(false);
                }}
                btnConfirm="Confirmar"
                btnCancel="Cancelar"
            />

        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        sqp: state.stockReducer.sqp
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        addForm: (form, images, callback) => {
            dispatch(StockService.addFormSqp(form, images, callback));
        },
        editForm: (form, images, callback) => {
            dispatch(StockService.editFormSqp(form, images, callback));
        },
        getAreasAll: (filter, callback) => {
            dispatch(StockService.getAreasAll(filter, callback));
        },
        getUlesAll: (filter, callback) => {
            dispatch(StockService.getUlesAll(filter, callback));
        },
        getVehiclesAll: (filter, callback) => {
            dispatch(StockService.getVehiclesAll(filter, callback));
        },
        getQuestionsAll: (filter, callback) => {
            dispatch(StockService.getQuestionsAll(filter, callback));
        },
        getAnswersByQuestionId: (id, callback) => {
            dispatch(StockService.getAnswersByQuestionId(id, callback));
        }
    }
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(SqpForm)));
